import React from 'react';
import styled from 'styled-components';

interface LoadingProps {
  small?: boolean;
}

export const Loader: React.FC<LoadingProps> = ({ small = false }) => {
  return (
    <Indicator data-small={small}>
      <div />
      <div />
      <div />
      <div />
    </Indicator>
  );
};

const Indicator = styled.div`
  display: inline-block;
  position: relative;

  &[data-small='false'] {
    width: 2.4rem;
    height: 2.4rem;

    div {
      border-width: 4px;
      border-style: solid;
    }
  }

  &[data-small='true'] {
    width: 1.4rem;
    height: 1.4rem;

    div {
      border-width: 2px;
      border-style: solid;
    }
  }

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-color: #fff transparent transparent transparent;

    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
